import { GreyStrip } from "@coworker/app/src/components/RoomSettings/Atoms/GreyStrip";
import { ArticleInGroups } from "@coworker/app/src/components/RoomSettings/Molecules/ArticleInGroups";
import React from "react";
import { useTranslation } from "@coworker/locales";
import { Articles } from "@coworker/app/src/components/RoomSettings/types/article";

interface ItemPlacementInGroupsProps {
  articles: Articles;
}

export const ItemPlacementInGroups = ({
  articles,
}: ItemPlacementInGroupsProps) => {
  const { t } = useTranslation();
  return (
    <>
      {articles?.some((a) => !!a.groupId) && (
        <GreyStrip text={t("inGroupsString")} />
      )}
      <ArticleInGroups articles={articles ?? []} />
    </>
  );
};
